<template>
  <div>
    <!--充值配置-->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>充值配置</span>
      </div>
      <!--冲多少送多少-->
      <el-form label-width="80px">
        <el-form-item label="满100送">
          <el-input
            v-model="form.giftAmount1"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 100 + (form.giftAmount1 | 0) }}</span>
        </el-form-item>
        <el-form-item label="满200送">
          <el-input
            v-model="form.giftAmount2"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 200 + (form.giftAmount2 | 0) }}</span>
        </el-form-item>
        <el-form-item label="满300送">
          <el-input
            v-model="form.giftAmount3"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 300 + (form.giftAmount3 | 0) }}</span>
        </el-form-item>
        <el-form-item label="满400送">
          <el-input
            v-model="form.giftAmount4"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 400 + (form.giftAmount4 | 0) }}</span>
        </el-form-item>
        <el-form-item label="满500送">
          <el-input
            v-model="form.giftAmount5"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 500 + (form.giftAmount5 | 0) }}</span>
        </el-form-item>
        <el-form-item label="满1000送">
          <el-input
            v-model="form.giftAmount6"
            placeholder="赠送金额"
          ></el-input>
          <span>= 总金额: {{ 1000 + (form.giftAmount6 | 0) }}</span>
        </el-form-item>
      </el-form>

      <!--button-->
      <el-button type="primary" @click="handleSave">保存</el-button>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {},
    handleSave() {
      //二次确认
      this.$confirm("确认保存吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //保存
          this.$message({
            type: "success",
            message: "保存成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消保存"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-top: 20px;
  .el-card__header {
    padding: 10px 0;
  }
  .clearfix {
    overflow: auto;
  }
  .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }
  .el-button {
    margin-right: 10px;
  }
  .el-input {
    width: 200px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__label {
    width: 100px;
  }
  .el-form-item__content {
    margin-left: 100px;
  }
  .el-form-item__content .el-input {
    width: 200px;
  }
  .el-form-item__content .el-input__inner {
    height: 30px;
  }
  .el-form-item__content .el-input__inner::-webkit-input-placeholder {
    color: #c0c4cc;
  }
  .el-form-item__content .el-input__inner::-moz-placeholder {
    color: #c0c4cc;
  }
  .el-form-item__content .el-input__inner:-ms-input-placeholder {
    color: #c0c4cc;
  }
  .el-form-item__content .el-input__inner:-moz-placeholder {
    color: #c0c4cc;
  }
  .el-form-item__content .el-input__inner:focus {
    border-color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// buyConfig.vue?0413178d